import styled from 'styled-components';

export default styled.p<any>`
  font-family: ${(props) =>
    props.fontFamily ? props.fontFamily : 'TTNormsPro-Regular'};
  margin-top: 0;
`;
